import module from 'fan/proyecto/module.js'
import template from './template.html'

const diacriticosRegex = /[,.\u0300-\u036f]/g
const diacriticosEspacios = /\s+\s/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').replace(diacriticosEspacios, ' ').toUpperCase().trim()

export class FanProyectoColaboradoresEditarAltasVincularComponent {
  constructor ($filter, $http, $q) {
    this.filterBy = $filter('filter')
    this.$http = $http
    this.$q = $q
    this.idProyecto = undefined
    this.data = undefined
    this.onChange = undefined

    this.completados = {}
    this.filtro = ''
    this.ignorarInvalidos = false
    this.invalidos = 0
    this.procesando = false
    this.resultados = undefined
    this.validos = []
  }

  $onChanges (changes) {
    if (changes.data) {
      this.buscar()
    }
  }

  buscar () {
    let requests = []
    this.procesando = true
    this.resultados = undefined
    this.invalidos = undefined

    if (!this.colaboradores) {
      requests.push(this.$http.get('api2/proyecto/colaboradores/alias', {params: {id_proyecto: this.idProyecto}})
        .then((response) => {
          this.colaboradores = response.data.map((colaborador) => {
            colaborador.alias = Object.values(colaborador.alias).map((alias) => normalizar(alias))
            return colaborador
          })
        }))
    }

    return this.$q.all(requests)
      .then(() => (this.vincular()))
      .finally(() => (this.procesando = false))
  }

  encontrarColaborador (item) {
    if (item.colaborador_id) {
      return this.colaboradores.find((colaborador) => colaborador.id_colaborador === item.colaborador_id)
    } else if (item.colaborador) {
      let colaboradorNombre = normalizar(item.colaborador)
      return this.colaboradores.find((colaborador) => colaborador.alias.indexOf(colaboradorNombre) >= 0)
    }
  }

  vincular () {
    this.completados = {
      colaborador: true,
    }

    this.data.map((item) => {
      let colaborador = this.encontrarColaborador(item)

      if (colaborador) {
        item.colaborador_id = colaborador.id_colaborador
        item.colaborador = colaborador.descripcion
        item.clase = item.clase || null
      } else {
        item.colaborador_id = false
      }

    })

    this.invalidos = this.data.filter((item) => !item.colaborador_id)
    this.validos = this.data.filter((item) => item.colaborador_id)

    this.notificar()
    this.filtrar()
  }

  notificar () {
    this.onChange({$event: {data: this.invalidos.length ? null : this.validos}})
  }

  filtrar () {
    this.resultados = this.filterBy(this.invalidos.length ? this.invalidos : this.validos, this.filtro)
  }

  ignorar () {
    this.invalidos = []
    this.notificar()
  }

  reiniciar () {
    this.colaboradores = undefined

    this.buscar()
  }
}

module.component('fanProyectoColaboradoresEditarAltasVincular', {
  controller: FanProyectoColaboradoresEditarAltasVincularComponent,
  template,
  bindings: {
    idProyecto: '<',
    data: '<',
    onChange: '&',
  },
})





// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/altas/vincular/component.js